export default "\n<app-rma-shipping-arrivals-list></app-rma-shipping-arrivals-list>\n\n"